import { translateUi } from "@/shared/lib/ui-translate";

/** Ключи словаря `Ui` для тиров — переводятся в момент форматирования. */
const TIER_RU: Record<string, string> = {
  UNRANKED: "litRiotRank.bezRanga",
  IRON: "litRiotRank.zhelezo",
  BRONZE: "litRiotRank.bronza",
  SILVER: "litRiotRank.serebro",
  GOLD: "litRiotRank.zoloto",
  PLATINUM: "litRiotRank.platina",
  EMERALD: "litRiotRank.izumrud",
  DIAMOND: "litRiotRank.almaz",
  MASTER: "litRiotRank.master",
  GRANDMASTER: "litRiotRank.grandmaster",
  CHALLENGER: "litRiotRank.chellendzher",
};

const DIV_RU: Record<string, string> = {
  I: "1",
  II: "2",
  III: "3",
  IV: "4",
};

const TIER_ORDER: Record<string, number> = {
  UNRANKED: 0,
  IRON: 1,
  BRONZE: 2,
  SILVER: 3,
  GOLD: 4,
  PLATINUM: 5,
  EMERALD: 6,
  DIAMOND: 7,
  MASTER: 8,
  GRANDMASTER: 9,
  CHALLENGER: 10,
};

const DIV_ORDER: Record<string, number> = {
  IV: 1,
  III: 2,
  II: 3,
  I: 4,
};

export function formatMinRequiredRankRu(raw?: string | null): string | null {
  const s = String(raw ?? "").trim();
  if (!s) return null;

  const normalized = s
    .toUpperCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const parts = normalized.split(" ");
  const tier = parts[0] ?? "UNRANKED";
  const div = parts[1];

  const tierKey = TIER_RU[tier];
  const tierRu = tierKey ? translateUi(tierKey) : s;
  if (tier === "MASTER" || tier === "GRANDMASTER" || tier === "CHALLENGER") {
    return tierRu;
  }

  const divRu = div ? (DIV_RU[div] ?? div) : null;
  return divRu ? `${tierRu} ${divRu}` : tierRu;
}

export function isAccountRankAllowed(
  accountRankRaw: string | null | undefined,
  requiredRankRaw: string | null | undefined,
): boolean {
  const required = toScore(requiredRankRaw);
  const account = toScore(accountRankRaw);
  return account >= required;
}

function toScore(rankRaw?: string | null): number {
  const { tier, div } = parseRank(rankRaw);
  const t = TIER_ORDER[tier] ?? 0;
  let d = DIV_ORDER[div] ?? 0;
  if (tier === "MASTER" || tier === "GRANDMASTER" || tier === "CHALLENGER") d = 4;
  return t * 10 + d;
}

function parseRank(rankRaw?: string | null): { tier: string; div: string } {
  const raw = String(rankRaw ?? "").trim();
  if (!raw) return { tier: "UNRANKED", div: "IV" };

  const u = raw
    .toUpperCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  for (const tier of [
    "CHALLENGER",
    "GRANDMASTER",
    "MASTER",
    "DIAMOND",
    "EMERALD",
    "PLATINUM",
    "GOLD",
    "SILVER",
    "BRONZE",
    "IRON",
  ]) {
    if (!u.includes(tier)) continue;

    if (tier === "MASTER" || tier === "GRANDMASTER" || tier === "CHALLENGER") {
      return { tier, div: "I" };
    }

    for (const div of ["IV", "III", "II", "I"]) {
      if (u.includes(` ${div}`) || u.endsWith(div)) return { tier, div };
    }

    return { tier, div: "IV" };
  }

  return { tier: "UNRANKED", div: "IV" };
}

